<template>
  <v-row>
    <v-col cols="12" lg="10" offset-lg="1">
      <v-breadcrumbs divider=">" :items="breadcrumbs" class="pb-3 pl-1" />
      <v-card class="mb-1">
        <v-card-title class="theme">
          <v-icon class="white--text">keyboard</v-icon>
          <span class="headline ml-2 white--text">Backoffice Item</span>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text class=" my-5 ck-content" style="color:#272929;font-family:Lato">
          <h1 class="pl-5 my-5 mx-5">{{ backoffice.name }}</h1>
          <h2 class="pl-5 my-5 mx-5">{{ backoffice.type }}</h2>
          <div class="px-5 mx-5 my-5 description" v-html="backoffice.description"></div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Constants } from "@/views/constants";

export default {
  name: "ReadOnlyBackoffice",
  data: () => ({
    breadcrumbs: Breadcrumbs.Backoffice.ReadOnly,
    backoffice: {
      type: "",
      name: "",
      description: "",
      visibility: "",
    },
  }),
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    setup() {
      this.$store
        .dispatch(Actions.Backoffice.Get, this.$route.params.id)
        .then((r) => {
          this.backoffice = { ...r.data };
        })
        .catch((e) => {
          console.error(Constants.BackOffice.Messages.Error.Get, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.BackOffice.Messages.Error.Get;
        });
    },
  },
  created() {
    if (this.userInfo) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>

<style>
h1{
  margin-bottom: 1rem;
  font-family: Roboto Slab;
}
h2,h3{
  font-family: Roboto Slab;
}
@media (max-width: 768px) {
    h1 {
        font-size: 20px;
    }
    h2{
      font-size: 18px
    }
    .ck-content{
      padding:0.1rem!important;
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    h1 {
        font-size: 22px;
    }
    h2{
      font-size: 20px;
    }
}
</style>>
